// NPM Imports
import React from "react";

// Internal Imports
import GroupSection from "./GroupSection";

export default function GroupedTable(props) {
  const { discount, groupBy, rows } = props;

  const groupByOptions = [
    ...new Set(rows.map(row => row.rowData[groupBy].cellData)),
  ];
  const groupedRows = [];

  groupByOptions.forEach(optionName => {
    const filteredRows = rows.filter(
      row => row.rowData[groupBy].cellData === optionName,
    );
    groupedRows.push({
      count: filteredRows.length,
      name: optionName,
      rows: filteredRows,
      metaData: discount.groups.find(
        group => group.group_by_value === optionName,
      ),
    });
  });

  return (
    <div className="rs-group-container">
      {groupedRows.map(group => (
        <GroupSection
          group={group}
          key={group.name}
          pricingPopUp={props.pricingPopUp}
          rows={rows}
          {...props}
        />
      ))}
    </div>
  );
}
